module.exports = __webpack_public_path__ + "static/img/ico_science@2x.f2c3aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talents/ico_science@2x.png
// module id = HWsy
// module chunks = 0